import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";

import OutsideClickHandler from "react-outside-click-handler";
import { ArrowDropDown } from "@material-ui/icons";
import classnames from "classnames";

const AccessDropdown = ({ value, onChange }) => {
  const [isDropdown, setIsDropdown] = useState(false);
  const [isLaunched, setIsLaunched] = useState(value);

  useEffect(() => {
    setIsLaunched(value);
  }, [value]);

  return (
    <OutsideClickHandler onOutsideClick={() => setIsDropdown(false)}>
      <span className='draftDropdown'>
        <Button
          color='primary'
          variant='contained'
          onClick={() => setIsDropdown(!isDropdown)}
          className={classnames(isLaunched ? "launchedBtn" : "")}
          // type="submit"
        >
          {isLaunched ? "Full Access" : "View Only"} <ArrowDropDown />
        </Button>

        {isDropdown && (
          <span className='draftInnerDropdown'>
            <Button
              color='primary'
              variant='contained'
              onClick={() => {
                setIsLaunched(false);
                setIsDropdown(!isDropdown);
                onChange(0);
              }}>
              View Only
            </Button>
            <Button
              color='primary'
              variant='contained'
              onClick={() => {
                setIsLaunched(true);
                setIsDropdown(!isDropdown);
                onChange(1);
              }}>
              Full Access
            </Button>
          </span>
        )}
      </span>
    </OutsideClickHandler>
  );
};

export { AccessDropdown };
